













































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { noAbc, nextInput } from '@/modules/budget/monitoring/input-forms/common/formaters';
import { hasUnfilledReason } from '@/modules/budget/monitoring/input-forms/components/application41/deviationValidation';

@Component({})
export default class GenView extends Vue {
    @Prop({ required: true, default: () => ({}) })
    private currBipForm!: any;
    @Prop({ required: true, default: '' })
    private tr_path!: string;
    @Prop({ required: true, default: () => ({}) })
    private currForm!: any;
    @Prop({ required: true, default: () => [] })
    private investOptions!: any[];
    // NTF.eAk.APPL41.01 — включает подсветку полей причины отклонения после неудачной
    // попытки сохранения (см. application_41.vue, saveData).
    @Prop({ required: false, default: false })
    private validationActive!: boolean;
    // Право редактирования карточки (application_41.vue -> FormData.vue) — все
    // редактируемые поля/селекторы вкладки "Общие сведения" запрещены на ввод без
    // него (см. targetIndicators.vue, тот же prop).
    @Prop({ required: false, default: false })
    private editAccess!: boolean;

    private nextInput: Function = nextInput;

    // "Период реализации", факт — раздельные поля "с"/"по" (год), каждое — просто
    // 4-значный год, не сумма: общий noAbc (число с минусом/десятичной точкой) тут
    // избыточен — своя локальная функция с regex "до 4 цифр" через noAbc(event, regex).
    private readonly YEAR_REGEX = '^\\d{0,4}$';

    private yearKeypress(event: KeyboardEvent) {
        noAbc(event, this.YEAR_REGEX);
    }

    private pairs: string[] = ['innovations', 'effectType', 'npaSuggestions'];

    private get financingSources(): { key: string; label: string }[] {
        return [
            { key: 'rb', label: this.t('rb') as string },
            { key: 'mb', label: this.t('mb') as string },
        ];
    }

    private financingValue(sourceKey: string, field: 'plan' | 'fact'): number {
        const financing = this.currBipForm && this.currBipForm.financing;
        const src = financing && financing[sourceKey];
        return (src && src[field]) || 0;
    }

    private formatAmount(v: number): string {
        return this.toNumber(v).toLocaleString('ru-RU');
    }

    private financingDeviation(sourceKey: string): number {
        return this.financingValue(sourceKey, 'fact') - this.financingValue(sourceKey, 'plan');
    }

    private financingDeviationText(sourceKey: string): string {
        const d = this.financingDeviation(sourceKey);
        const abs = Math.abs(d).toLocaleString('ru-RU');
        return d < 0 ? `- ${abs}` : `${abs}`;
    }

    private t(key: string) {
        return this.$t(`${this.tr_path}gen_view.${key}`);
    }

    private nt(key: string) {
        return this.$t(`${this.tr_path}notifications.${key}`);
    }

    // NTF.eAk.APPL41.01 — план (currBipForm.impl_period, "YYYY - YYYY") vs факт
    // (bip_form_info.impl_period.fact_from/fact_to); пока факт не заполнен — сверять не с чем.
    private get implPeriodInvalid(): boolean {
        const info = this.currBipForm && this.currBipForm.bip_form_info && this.currBipForm.bip_form_info.impl_period;
        if (!info) return false;
        return this.implPeriodDeviates && hasUnfilledReason(info.deviation_reason);
    }

    // Факт периода реализации заполнен (хотя бы одна граница) и не совпадает с планом.
    private get implPeriodDeviates(): boolean {
        const info = this.currBipForm && this.currBipForm.bip_form_info && this.currBipForm.bip_form_info.impl_period;
        if (!info) return false;
        const { fact_from, fact_to } = info;
        if (!fact_from && !fact_to) return false;
        const [planFrom, planTo] = String(this.currBipForm.impl_period || '').split('-').map((s: string) => s.trim());
        return (!!fact_from && String(fact_from) !== planFrom) || (!!fact_to && String(fact_to) !== planTo);
    }

    // Текст NTF.eAk.APPL41.01 под полем причины периода реализации — везде, где поле
    // подсвечено красным: при проверке на сохранении или живым ФЛК-валидатором.
    private get implPeriodReasonMissing(): boolean {
        return (this.validationActive && this.implPeriodInvalid) || !!this.currBipForm.flk_impl_period_deviation;
    }

    // То же для причины по источнику финансирования (РБ/МБ).
    private financingReasonMissing(sourceKey: string): boolean {
        return (this.validationActive && this.financingInvalid(sourceKey))
            || (!!this.currBipForm.flk_financing_deviation && this.financingDeviation(sourceKey) !== 0);
    }

    // Зелёный текст причины периода реализации — только когда факт указан целиком
    // (оба поля "с"/"по") и отклонения нет (годы факта совпадают с годами плана,
    // включая случай "Отклонений нет" по плейсхолдеру, когда факт не указан вовсе).
    // Если отклонение есть (даже с указанной причиной) — обычный цвет текста.
    private get implPeriodOk(): boolean {
        const info = this.currBipForm && this.currBipForm.bip_form_info && this.currBipForm.bip_form_info.impl_period;
        if (!info) return true;
        const { fact_from, fact_to } = info;
        if (!fact_from && !fact_to) return true;
        if (!fact_from || !fact_to) return false;
        const [planFrom, planTo] = String(this.currBipForm.impl_period || '').split('-').map((s: string) => s.trim());
        return String(fact_from) === planFrom && String(fact_to) === planTo;
    }

    private financingInvalid(sourceKey: string): boolean {
        const dev = this.financingDeviation(sourceKey);
        const reasons = this.currBipForm && this.currBipForm.bip_form_info && this.currBipForm.bip_form_info.financing && this.currBipForm.bip_form_info.financing.deviation_reason;
        const reason = reasons ? reasons[sourceKey] : null;
        return dev !== 0 && hasUnfilledReason(reason);
    }

    private field(key: string): string {
        return (this.currBipForm && this.currBipForm[key]) || '';
    }

    // Локализованное поле (ru/kk с фолбэком на ru) — сейчас только для industry_ru/industry_kk
    // (Отрасль, RQ.eAk.APPL41.09, графа 13: project_bank_form_data.branch -> dict_project_branch).
    private localized(key: string): string {
        if (!this.currBipForm) return '';
        return this.currBipForm[`${key}_${this.$i18n.locale}`] || this.currBipForm[`${key}_ru`] || '';
    }

    // Период план / Рабочих мест: период реализации (Банк проектов, impl_period) +
    // количество созданных рабочих мест (RQ.eAk.APPL41.11 — критерий отбора БИП 2.1.,
    // criteriaIndicators->>'2.1.', currBipForm.jobs_created_perm с бэка). Бэк отдаёт
    // null, если критерия нет ни у одного связанного БИП — по RQ.eAk.APPL41.11.2 в
    // этом случае показатель и единица измерения не отображаются вовсе (не «0»).
    private get planPeriodJobs(): string {
        if (!this.currBipForm) return '';
        const period = this.currBipForm.impl_period || '';
        const jobs = this.currBipForm.jobs_created_perm;
        const jobsText = (jobs !== null && jobs !== undefined && jobs !== '') ? `${jobs} ${this.t('jobs_unit')}` : '';
        if (period && jobsText) return `${period} · ${jobsText}`;
        return period || jobsText;
    }

    private get projectName(): string {
        if (!this.currBipForm) return '';
        return this.currBipForm[`name_${this.$i18n.locale}`] || this.currBipForm.name_ru || '';
    }

    // Список кодов КБК (АБП.БП.БПП, RQ.eAk.APPL41.10) — у одного ГИП может быть
    // несколько БП (prg), каждый со своим подмножеством БПП (ppr): бэк отдаёт
    // готовые пары prg_ppr_list (см. get_gip_forms/input_form_41.py), по одному
    // коду на пару, например «271.114.011», «271.114.015», «271.009.011». Если
    // пар нет вовсе — список пуст (карточка без данных Скорр.плана).
    private get kbkCodes(): string[] {
        if (!this.currBipForm || this.currBipForm.abp === undefined || this.currBipForm.abp === null) return [];
        const pad = (v: any) => String(v).padStart(3, '0');
        const pairs: any[] = (this.currBipForm.prg_ppr_list || []).filter((p: any) => p && p.prg !== null && p.prg !== undefined);
        if (!pairs.length) return [];
        return pairs.map((p: any) => (
            p.ppr !== null && p.ppr !== undefined
                ? `${pad(this.currBipForm.abp)}.${pad(p.prg)}.${pad(p.ppr)}`
                : `${pad(this.currBipForm.abp)}.${pad(p.prg)}`
        ));
    }

    // Отчётный квартал по месяцу фильтра (currForm.month, 0-based) — тот же принцип,
    // что и _get_quarter_and_control_date в inputForms/forms/input_form_41.py:
    // последний завершённый квартал перед выбранным месяцем (апрель — I, июль — II,
    // октябрь — III; январь — IV предыдущего года).
    private get quarterLabel(): string {
        const QUARTER_ROMAN = ['I', 'II', 'III', 'IV'];
        const month = this.currForm && this.currForm.month;
        if (month === null || month === undefined) return '';
        const monthNumber = Number(month) + 1;
        if (!(monthNumber >= 1 && monthNumber <= 12)) return '';
        const completedQuarters = Math.floor((monthNumber - 1) / 3);
        const quarter = QUARTER_ROMAN[completedQuarters === 0 ? 3 : completedQuarters - 1];
        return `${quarter} ${this.t('quarter')}`;
    }

    private toNumber(v: any): number {
        if (v === null || v === undefined || v === '') return 0;
        const n = Number(String(v).replace(/\s/g, '').replace(',', '.'));
        return isNaN(n) ? 0 : n;
    }

}
